import React, { useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../images/back.svg";
import { Checkbox, DatePicker, InputNumber } from "antd";
import { Controller, FormProvider, useForm } from "react-hook-form";
import TextArea from "../../../components/Form/TextArea";
import dayjs from "dayjs";
import TextInput from "../../../components/Form/TextInput";
import axios from "../../../axios/axios";
import { toast } from "react-toastify";

const IssueAAF = () => {
  const AgentId = localStorage.getItem("agentId");
  const location = useLocation();
  const navigate = useNavigate();
  const AppId = location.state?.floorData?.AppId;
  const DataObj = location.state.dataObj;
  const FloorCaseDetails =
    location.state !== null && location.state !== undefined
      ? location.state?.floorData?.FloorCaseDetails
      : {};
  const Cart =
    Object.keys(FloorCaseDetails)?.length > 0 &&
      FloorCaseDetails?.cart["1"] !== undefined
      ? FloorCaseDetails?.cart["1"]?.agent
      : Array.isArray(FloorCaseDetails?.cart)
        ? FloorCaseDetails?.cart[0]?.agent
        : FloorCaseDetails?.cart;
  const [isVoucherRejected, setVoucherRejected] = useState(false);

  const GetRedemptionCount = (max, redemedqty) => {
    const temp = max - redemedqty;
    if (temp > 0) {
      return temp;
    } else {
      return 0;
    }
  };
  const formValues =
    DataObj !== null && DataObj !== undefined
      ? DataObj
      : {
        agent_admin_fee: "",
        agent_interest_rate:
          Cart?.is_voucher == 1
            ? Cart.vouchers?.interest_rate.slice(
              0,
              Cart?.product?.interest_from.indexOf(".") + 2
            )
            : "",
        agent_voucher_approved_status: false,
        agent_approved_status: 1,
        agent_other_conditions: "",
      };
  // console.log("formValues=========", formValues)

  const methods = useForm({
    defaultValues: useMemo(() => {
      return formValues;
    }, [formValues, FloorCaseDetails, Cart]),
  });

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    setValue,
  } = methods;

  const onSubmit = async (data) => {
    const dataObj = {
      ...data,
      agent_voucher_approved_status:
        Cart?.is_voucher == 1 && !data?.agent_voucher_approved_status ? 1 : 2,
      preIssuedFloorAmount: location.state.intended_floor_amount,
    };
    // console.log("payload from issue to preview==========", dataObj)
    navigate("/flooring-cases/view/issueAAF/preview", {
      state: {
        floorData: location.state.floorData,
        dataObj: dataObj,
        AppId: AppId,
        AgentId: AgentId,
        issueAAf: true,
        isVoucherRejected: isVoucherRejected,
      },
    });
  };

  const handleCheckboxChange = (e) => {
    setVoucherRejected(e.target.checked);
  };

  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/flooring-cases/view");
              }}
            >
              <BackIcon />
            </span>
            Flooring Cases
          </h1>
        </div>
      </header>
      <section className="issues-aaf-section">
        <h1>Issue AAF</h1>
        <p>
          Issue Approval Advice for Flooring for the Dealer. If the AAF is
          signed, the deal will be finalized.
        </p>
        {Cart?.is_voucher == 1 && (
          <div className="flooring-details-card !max-w-[920px] mb-5">
            <h2>
              <span>Voucher Applied</span>
            </h2>
            <h3>
              Interest Rate:{" "}
              <span>
                {" "}
                {Cart?.vouchers?.interest_rate.slice(
                  0,
                  Cart?.vouchers?.interest_rate.indexOf(".") + 2
                )}
                %
              </span>
            </h3>
            <h3>
              Eligible Floor Amt:{" "}
              <span>
                $
                {Cart?.vouchers?.amount_from.slice(
                  0,
                  Cart?.vouchers?.amount_from.indexOf(".")
                )}{" "}
                - $
                {Cart?.vouchers?.amount_to.slice(
                  0,
                  Cart?.vouchers?.amount_to.indexOf(".")
                )}
              </span>
            </h3>
            <h3>
              Voucher(s) left:
              {Cart?.vouchers?.voucher_qty_type?.value == 0 ? (
                <span>{Cart?.vouchers?.voucher_qty_type?.label}</span>
              ) : (
                <span>{`${GetRedemptionCount(
                  Cart?.vouchers?.redeemed_qty,
                  Cart?.vouchers?.qty
                )} / ${Cart?.vouchers?.qty}`}</span>
              )}
            </h3>
          </div>
        )}
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {Cart?.is_voucher == 1 && (
              <div className="input-group">
                <label htmlFor="RejectAppliedVoucher" className="checkbox">
                  <Controller
                    control={control}
                    name="agent_voucher_approved_status"
                    rules={{
                      required: false,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <Checkbox
                          onChange={(val) => {
                            field.onChange(val.target.checked);
                            if (val.target.checked) {
                              setValue("agent_interest_rate", "");
                            } else {
                              setValue(
                                "agent_interest_rate",
                                Cart?.is_voucher == 1 ? Cart.vouchers?.interest_rate : ""
                              );
                            }
                            setVoucherRejected(val.target.checked);
                          }}
                          checked={field.value}
                          id="RejectAppliedVoucher"
                        />
                      );
                    }}
                  />
                  Reject Applied Voucher
                </label>
              </div>
            )}
            <div className="input-one-line">
              <Controller
                control={control}
                name="intended_floor_amount"
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <div className="input-group">
                      <label className="!w-full">Floor Amount</label>
                      <InputNumber
                        type="number"
                        prefix="$"
                        name={field.name}
                        ref={field.ref}
                        value={field.value}
                        status={fieldState?.invalid ? "error" : null}
                        prefixCls="sign_Icon"
                        placeholder="0.00"
                        precision={2}
                        step="0.01"
                        className="max-w-[490px] min-w-[490px] w-full cusAdmInputNumber2"
                        onChange={(val) => field.onChange(val)}
                      // disabled={true}
                      />
                    </div>
                  );
                }}
              />
            </div>
            <div className="input-one-line">

              <Controller
                name="agent_interest_rate"
                control={control}
                rules={{
                  required: "Interest Rate is required",
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label="Interest per 30 days"
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="Enter a Interest per 30 days"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="max-w-[490px] min-w-[490px] w-full cusAdmInputNumber2"
                    disabled={
                      !watch("agent_voucher_approved_status") &&
                      Cart?.is_voucher == 1
                    }
                  />
                )}
              />
              <Controller
                control={control}
                name="agent_admin_fee"
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <div className="input-group">
                      <label className="!w-full">Admin Fee</label>
                      <InputNumber
                        type="number"
                        prefix="$"
                        name={field.name}
                        ref={field.ref}
                        value={field.value}
                        status={fieldState?.invalid ? "error" : null}
                        prefixCls="sign_Icon"
                        placeholder="0.00"
                        precision={2}
                        step="0.01"
                        className="max-w-[490px] min-w-[490px] w-full cusAdmInputNumber2"
                        onChange={(val) => field.onChange(val)}
                      />
                    </div>
                  );
                }}
              />
            </div>
            <div>
              <Controller
                name="agent_other_conditions"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState }) => (
                  <TextArea
                    label="Other Conditions"
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="Enter a Other Conditions"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="max-w-[490px] w-full"
                  />
                )}
              />
            </div>
            <div className="text-right mt-10">
              <button className="sav_btn" type="submit">
                Preview AAF
              </button>
            </div>
          </form>
        </FormProvider>
      </section>
    </section>
  );
};

export default IssueAAF;
